import { DATE_PICKER_LABELS } from './UiDatePicker.constants';

type UiDatePickerFootProps = {
    todayDisabled: boolean;
    onClear: () => void;
    onToday: () => void;
};

/** Clear on the left, today on the right, like the browser's own picker. */
export function UiDatePickerFoot({ todayDisabled, onClear, onToday }: UiDatePickerFootProps) {
    return (
        <div className="form-datepicker-foot">
            <button type="button" className="form-datepicker-action" onClick={onClear}>
                {DATE_PICKER_LABELS.clear}
            </button>

            <button type="button" className="form-datepicker-action" disabled={todayDisabled} onClick={onToday}>
                {DATE_PICKER_LABELS.today}
            </button>
        </div>
    );
}
